export default "/images/clock.svg?38585fec598ef79bfbd0c5c4b099074a";